export default __webpack_public_path__ + "static/asu-hover-d7e1a37761c66b080a9c7849763357e2.png";